import { APP_BASE_HREF, PlatformLocation } from '@angular/common';
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import {
  APP_INITIALIZER,
  Injector,
  isDevMode,
  LOCALE_ID,
  NgModule,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  TranslateModule,
  TranslateLoader,
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
} from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppInitializerService } from './app-initializer.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HeaderComponent } from './layout/header/header.component';
import { SharedModule } from '@shared/shared.module';
import { NavbarComponent } from './layout/navbar/navbar.component';
import { UserBarComponent } from './layout/user-bar/user-bar.component';
import { NavigatorComponent } from './layout/navigator/navigator.component';
import { GuestModule } from './page/guest/guest.module';
import { LoggedModule } from './page/logged/logged.module';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ApiInterceptor } from './interceptor/api.interceptor';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { initializeKeycloak } from '@auth/keycloak.conf';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { QRCodeModule } from 'angularx-qrcode';
import { RoleService } from '@shared/services/role/role.service';

registerLocaleData(localeIt);

export function getBaseHref(platformLocation: PlatformLocation): string {
  return platformLocation.getBaseHrefFromDOM();
}

export function TranslationLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/languages/', '.json');
}

export function init_app(appLoadService: AppInitializerService) {
  return () => appLoadService.load();
}

export class CustomMissingTranslationHandler
  implements MissingTranslationHandler
{
  handle(params: MissingTranslationHandlerParams): any {
    if (isDevMode()) {
      if (params.key != 'dummy_translation') {
        /* console.log('Missing translate key: ', params.key); */
      }
    }
    return params.key;
  }
}

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    HeaderComponent,
    NavbarComponent,
    UserBarComponent,
    NavigatorComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    KeycloakAngularModule,
    NgxUiLoaderModule,
    // NgxUiLoaderRouterModule,
    SharedModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'it',
      loader: {
        provide: TranslateLoader,
        useFactory: TranslationLoaderFactory,
        deps: [HttpClient],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler,
      },
    }),
    GuestModule,
    LoggedModule,
    NgxPermissionsModule.forRoot(),
    QRCodeModule,
  ],
  providers: [
    {
      provide: APP_BASE_HREF,
      useFactory: getBaseHref,
      deps: [PlatformLocation],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, RoleService],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [AppInitializerService, Injector],
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'it-IT',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
